import { useTheme } from "../context/ThemeContext";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ className = "" }) {
    const { theme, toggle } = useTheme();
    const isDark = theme === "dark";
    return (
        <button
            onClick={toggle}
            aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
            data-testid="theme-toggle"
            className={`p-2 rounded-full border border-ink/15 text-ink-muted hover:text-ink hover:border-ink/30 transition-colors ${className}`}
        >
            {isDark
                ? <Sun strokeWidth={1.5} className="w-4 h-4" />
                : <Moon strokeWidth={1.5} className="w-4 h-4" />}
        </button>
    );
}
